<template>
  <v-layout column class="notification-container">
    <div class="notification-group">
      <div class="notification-group-title">
        {{ adminText('adminAll.visitor_notifications_dfbb0c', 'Visitor notifications') }}
      </div>
      <div class="notifications-container">
        <div class="notification">
          <div class="notification-text">
            <div class="name">{{ adminText('adminAll.event_cancellation_notification_a76eaf', 'Event Cancellation Notification') }}</div>
            <div class="desc">{{ adminText('adminAll.notify_me_if_the_event_is_canceled_and_provide_information_e21465', 'Notify me if the event is canceled and provide information about refunds.') }}</div>
          </div>
          <div class="switch">
            <label class="notification-switch">
              <input v-model="notifications.eventCancelNotification" type="checkbox">
              <span class="notification-slider round" />
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="userVerified" class="notification-group">
      <div class="notification-group-title">
        {{ adminText('adminAll.organiser_notifications_b845da', 'Organiser notifications') }}
      </div>
      <div class="notifications-container">
        <div v-for="notification in organizationNotifications" :key="notification.type" class="notification">
          <div class="notification-text">
            <div class="name">{{ notification.name }}</div>
            <div class="desc">{{ notification.description }}</div>
          </div>
          <div class="switch">
            <label class="notification-switch">
              <input v-model="notifications[notification.type]" type="checkbox">
              <span class="notification-slider round" />
            </label>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
export default {
  mixins: [AdminContext, AdminAllMessages],
  computed: {
    organizationNotifications() { return [
      { name: this.adminText('adminAll.ticket_sale_083502', 'Ticket sale'), description: this.adminText('adminAll.notify_me_whenever_a_ticket_is_sold_81f941', 'Notify me whenever a ticket is sold.'), type: 'ticketSaleNotification'},
      { name: this.adminText('adminAll.50_of_each_ticket_type_sold_567b16', '50% of each ticket type sold'), description: this.adminText('adminAll.notify_me_when_50_of_each_ticket_type_for_the_event_is_sol_379834', 'Notify me when 50% of each ticket type for the event is sold.'), type: 'halfTicketsSoldNotification'},
      { name: this.adminText('adminAll.sale_ends_952a1e', 'Sale ends'), description: this.adminText('adminAll.notify_me_of_unsold_tickets_for_each_type_one_day_before_s_846933', 'Notify me of unsold tickets for each type one day before sales end.'), type: 'unsoldTicketsNotification'},
      { name: this.adminText('adminAll.low_ticket_availability_647af4', 'Low ticket availability'), description: this.adminText('adminAll.notify_me_if_less_than_10_of_the_total_tickets_are_left_fo_eec58f', 'Notify me if less than 10% of the total tickets are left for sale.'), type: 'lowAvailabilityNotification'},
      { name: this.adminText('adminAll.sold_out_02ff65', 'Sold out'), description: this.adminText('adminAll.notify_me_when_a_ticket_type_is_sold_out_262391', 'Notify me when a ticket type is sold out.'), type: 'ticketsSoldOutNotification'},
      { name: this.adminText('adminAll.long_idle_period_notification_4f889c', 'Long Idle Period Notification'), description: this.adminText('adminAll.notify_me_if_the_availability_date_of_a_ticket_is_signific_ec85a1', 'Notify me if the availability date of a ticket is significantly earlier than the event date.'), type: 'longIdlePeriodNotification'},
      { name: this.adminText('adminAll.new_r1_invoice_07e0cd', 'New R1 invoice'), description: this.adminText('adminAll.notify_me_when_a_new_r1_invoice_is_created_0c2e23', 'Notify me when a new R1 invoice is created.'), type: 'newR1InvoiceNotification'},
    ] },
  },
  name: 'user-profile',
  props: {
    notificationData: {
      type: Object,
      default: {},
    },
    userVerified: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notifications: this.notificationData,

    }
  },
}
</script>

<style scoped>
.notification-container {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 2rem;
  gap: 32px;
}
.notification-group {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
}
.notification-group-title {
  align-self: stretch;
  color: #0277BD;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.6px;
}
.notifications-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: start;
  width: 100%;
}
.notification {
  display: flex;
  width: 100%;
  padding: 8px 0;
  align-items: flex-start;
  gap: 24px;
  border-bottom: 1px solid #F5F5F5;
}
.notification-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: center;
}
.notification-text .name {
  align-self: stretch;
  color: #333;
  font-family: "Source Sans Pro";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.notification-text .desc {
  align-self: stretch;
  color: #666;
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.switch {
  height: 68px;
  align-content: center;
}
.notification-switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 32px;
}
.notification-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.notification-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  border: 2px solid #979797;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.notification-slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 6px;
  bottom: 6px;
  background-color: #979797;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .notification-slider {
  background-color: #0277BD;
  border: none;
}
input:focus + .notification-slider {
  box-shadow: 0 0 1px #0277BD;
}
input:checked + .notification-slider:before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
  background-color: white;
  height: 24px;
  width: 24px;
  left: 6px;
  bottom: 4px;
}
.notification-slider.round {
  border-radius: 34px;
}
.notification-slider.round:before {
  border-radius: 50%;
}
</style>
